import React, { useMemo, useCallback } from "react";
import {
  Box,
  Typography,
  withStyles,
} from "@material-ui/core";
import { ResizableTable } from "../../components/resizableTable/ResizableTable";

const styles = (theme) => ({
  tableContainer: {
    marginTop: theme.spacing(2),
  },
  title: {
    marginBottom: theme.spacing(1),
    fontWeight: 600,
    fontSize: "1rem",
    textAlign: "center",
  },
  emptyMessage: {
    padding: "24px",
    color: "#999",
    textAlign: "center",
  },
});

function NewCustomerDealsWonTable({ classes, summaryTable }) {
  // Create columns for ResizableTable
  const tableColumns = useMemo(() => {
    if (!summaryTable || !summaryTable.columns || summaryTable.columns.length === 0) {
      // Default columns when no data
      return [
        {
          label: 'Metric',
          sortable: true,
          subColumns: [{
            label: 'Metric',
            field: 'label',
            type: 'text',
            align: 'left',
            width: 150,
            sortable: true,
            filterable: true,
          }],
          headerBgColor: '#4472C4',
          headerTextColor: '#ffffff',
        },
        {
          label: 'Total',
          sortable: false,
          subColumns: [{
            label: 'Total',
            field: 'Total',
            type: 'number',
            align: 'center',
            width: 100,
            sortable: false,
          }],
          headerBgColor: '#4472C4',
          headerTextColor: '#ffffff',
        },
      ];
    }

    const columns = [
      {
        label: 'Metric',
        sortable: true,
        subColumns: [{
          label: 'Metric',
          field: 'label',
          type: 'text',
          align: 'left',
          width: 150,
          sortable: true,
          filterable: true,
        }],
        headerBgColor: '#4472C4',
        headerTextColor: '#ffffff',
      },
    ];

    // Add dynamic columns from summaryTable.columns
    summaryTable.columns.forEach((col) => {
      columns.push({
        label: col,
        sortable: true,
        subColumns: [{
          label: col,
          field: col,
          type: 'number',
          align: 'center',
          width: col === 'Total' ? 100 : 120,
          sortable: true,
          filterable: true,
        }],
        headerBgColor: '#4472C4',
        headerTextColor: '#ffffff',
      });
    });

    return columns;
  }, [summaryTable]);

  // Transform rows for ResizableTable
  const tableRows = useMemo(() => {
    if (!summaryTable || !summaryTable.rows || summaryTable.rows.length === 0) {
      return [];
    }

    return summaryTable.rows.map((row, index) => ({
      ...row,
      rowKey: row.label || `row_${index}`,
    }));
  }, [summaryTable]);

  // Get cell value function
  const getCellValue = useCallback((row, field) => {
    if (field === 'label') {
      return row[field] || '';
    }
    const value = row[field];
    if (value === undefined || value === null) {
      return '-';
    }
    return value;
  }, []);

  // Get cell style function
  const getCellStyle = useCallback((row, field) => {
    const baseStyle = {};

    // Style for the metric label column
    if (field === 'label') {
      baseStyle.fontWeight = 600;
      baseStyle.backgroundColor = '#f5f5f5';
    }

    // Style for Total column
    if (field === 'Total') {
      baseStyle.backgroundColor = '#e8f0fe';
      baseStyle.fontWeight = 600;
    }

    return baseStyle;
  }, []);

  // Handle empty data
  if (!summaryTable || !summaryTable.columns || !summaryTable.rows || summaryTable.columns.length === 0) {
    return (
      <div className={classes.tableContainer}>
        <Typography variant="h6" className={classes.title}>
          {summaryTable?.title || "Cumulative closures by source"}
        </Typography>
        <Box className={classes.emptyMessage}>
          No data available
        </Box>
      </div>
    );
  }

  const { title } = summaryTable;

  return (
    <div className={classes.tableContainer}>
      <ResizableTable
        columns={tableColumns}
        rows={tableRows}
        getCellValue={getCellValue}
        getCellStyle={getCellStyle}
        rowKey="rowKey"
        hideSubHeaderRow={true}
        heading={title || "Cumulative closures by source"}
        maxWidth="30%"
      />
    </div>
  );
}

export default withStyles(styles)(NewCustomerDealsWonTable);
